import {gql} from "@apollo/client";

// 客服系统专属查询，后端以 CS_EXCEPTION / CS_PACKAGE 资源码鉴权。
// 用别名保持返回字段名与原共享查询一致，调用方读取结果的代码无需改动。

export const GET_ALL_EXCEPTION_FOR_CS = gql`
    query CustomerServiceExceptionDictionaryQuery {
        getExceptionDictionaryForHeadquarters: getExceptionDictionaryForCustomerService {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export const GET_ALL_EXCEPTION_DICT_FOR_CS = gql`
    query CustomerServiceExceptionDictionaryAllQuery {
        getExceptionDictionaryAll: getExceptionDictionaryAllForCustomerServiceExceptions {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export const GET_NEXT_ACTION_LIST_FOR_CS = gql`
    query CustomerServiceNextActionQuery {
        getNextActionList: getNextActionListForCustomerService {
            name
            value
        }
    }
`;

export const GET_WAREHOUSES_FOR_CS = gql`
    query CustomerServiceWarehouseQuery {
        warehouses: getWarehouseListForCustomerService {
            id
            name
            siteType
            parentSiteId
            sortingCode
        }
    }
`;

export const GENERATE_EXCEPTION_DOWNLOAD_REPORT_FOR_CS = gql`
    mutation CustomerServiceGenerateExceptionDownloadReport($filters: OrderFiltersTypeInput, $timezone: String) {
        generateExceptionDownloadReport: generateExceptionDownloadReportForCs(filters: $filters, timezone: $timezone)
    }
`;
